import Head from 'next/head';
import { useRouter } from 'next/router';

// import { defaultSeoImage, MetaImageTags } from '../helpers/seo';
import { useMetadata } from '../hooks/metadata';

// import { materialMatcher, newsMatcher } from './MaterialContent/helpers/useInfiniteScroll';

export default function Seo() {
  const { asPath } = useRouter();
  const [pathname] = asPath.split('?');

  const metadata = useMetadata(pathname);

  // const isNews = newsMatcher(pathname);
  // const isArticle = materialMatcher(pathname);

  if (!metadata || !metadata.title) {
    return null;
  }

  return (
    <Head>
      <title key="title">{metadata.title}</title>
      <meta
        name="robots"
        content={`${metadata.indexingDisabled ? 'noindex, nofollow' : 'index, follow'}, max-image-preview:large`}
      />
      <meta key="description" name="description" content={metadata.description} />
      <link rel="canonical" href={metadata.canonical || `https://www.sravni.ru${pathname}`} />
      <meta property="og:type" content="article" />
      <meta key="og:description" property="og:description" content={metadata.ogDescription} />
      <meta key="og:title" property="og:title" content={metadata.ogTitle} />
      {metadata.ogImage && (
        <>
          <meta property="og:image" content={metadata.ogImage} />
          <meta property="og:image:width" content={`${metadata.ogImageWidth}`} />
          <meta property="og:image:height" content={`${metadata.ogImageHeight}`} />
        </>
      )}
      {/* этот фикс нужен для того что бы обойти багу с дублированием тегов в next/head*/}
      {/*{!isNews && !isArticle && <MetaImageTags picture={defaultSeoImage} />}*/}
      {metadata.schema ? (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(metadata.schema) }} />
      ) : null}
    </Head>
  );
}
